import { useState } from 'react'
import {
  IconButton,
  Typography,
  Box,
  makeStyles,
  createStyles,
} from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu'
import CloseIcon from '@material-ui/icons/Close'
import Modal from '@mui/material/Modal'
import Fade from '@mui/material/Fade'
import Backdrop from '@mui/material/Backdrop'
import Button from '@mui/material/Button'

import './drawer.scss'

const useStyles = makeStyles(() =>
  createStyles({
    link: {
      textDecoration: 'none',
      color: '#DAA520',
      fontSize: '18px',
      fontWeight: 'bold',
      letterSpacing: '0.1em',
    },
    icon: { color: '#DAA520' },
    logo: {
      fontSize: '1.6em',
      fontWeight: 'bold',
      letterSpacing: '.15em',
      color: '#DAA520',
      textAlign: 'center',
    },
  })
)

function DrawerComponent() {
  const classes = useStyles()
  const [openDrawer, setOpenDrawer] = useState(false)

  return (
    <div>
      {/* Modal as menu */}
      


<Modal
  aria-labelledby="menu-modal-title"
  aria-describedby="menu-modal-description"
  open={openDrawer}
  onClose={() => setOpenDrawer(false)}
  closeAfterTransition
  BackdropComponent={Backdrop}
  BackdropProps={{
    timeout: 500,
    style: { backgroundColor: 'rgba(0, 0, 0, 0.95)' },
  }}
>
  <Fade in={openDrawer}>
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80vw',
        maxWidth: '400px',
        bgcolor: 'transparent',
        borderRadius: '20px',
        textAlign: 'center',
        px: 3,
      }}
    >
      <p style={{
        fontSize: '1.6em',
        fontWeight: 'bold',
        letterSpacing: '.15em',
        color: '#DAA520',
        marginBottom: '20px',
        textAlign: 'center',
      }}>
        TEMPLAR G✠LD
      </p>

      <p style={{
        fontSize: '1.4em',
        fontWeight: 'bold',
        letterSpacing: '.1em',
        color: '#DAA520',
        marginBottom: '28px',
        textAlign: 'center',
        lineHeight: '1.5em'
      }}>
        PAUPERES COMMILITONES CHRISTI<br />
        TEMPLIQUE SALOMONICI
      </p>

      <Button
        variant="outlined"
        fullWidth
        onClick={() => setOpenDrawer(false)}
        sx={{
          borderRadius: '50px',
          border: '2px solid #DAA520',
          color: '#DAA520',
          fontWeight: 'bold',
          letterSpacing: '.05em',
          py: 1.2,
          px: 3,
        }}
      >
        CLOSE
      </Button>
    </Box>
  </Fade>
</Modal>



      {/* Menu toggle button */}
      <IconButton
        className={classes.icon}
        onClick={() => setOpenDrawer(true)}
      >
        <MenuIcon />
      </IconButton>
    </div>
  )
}

export default DrawerComponent